import { percentSingleDecimal } from '../download-data-styles';
import {
  renderSectionHeaderAsOfDate,
  renderMainRightCell,
  renderMainLeftCell,
  renderSoftLeftCell,
  renderRowGaps,
  renderColumnGaps
} from '../helpers';

export const renderMarketCapRow = marketCapCategory => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(marketCapCategory.label);
  rowString += renderMainRightCell(marketCapCategory.data, percentSingleDecimal);
  rowString += `</tr>`;
  return rowString;
};

export const renderMarketCapCompositeRow = data => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(`${data.composite.label} (million)`);
  rowString += renderMainRightCell(data.composite.data);
  rowString += renderColumnGaps();
  rowString += renderSoftLeftCell(data.asOfDateString);
  rowString += `</tr>`;
  return rowString;
};

export const marketCapModule = data => {
  let marketCapString = ``;
  marketCapString += renderSectionHeaderAsOfDate('Market Capitalization', data.marketCapAsOfDate);
  marketCapString += renderRowGaps();
  data.dataSet.forEach(marketCapCategory => {
    marketCapString += renderMarketCapRow(marketCapCategory);
  });
  marketCapString += renderMarketCapCompositeRow(data);
  marketCapString += renderRowGaps(2);
  return marketCapString;
};
